import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ChannelLink = styled.a`
    width: 240px;
    max-width: 240px;
    display: flex;
    align-items: center;

    @media only screen and (max-width: 1023px) {
        flex-direction: column;
        align-items: flex-start;
        width: 140px;
        max-width: 140px;
    }

    @media only screen and (max-width: 374px) {
        width: 115px;
        max-width: 115px;
    }
`;

export const ChannelImageBox = styled.div`
    position:  relative;
    display: inline;
    width: 52px;
    height: 52px;
    overflow: hidden;
    background-color: white;
    border-radius: ${BorderRadius.labelRadius};

    img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        z-index: 1;
    }

    &:before {
        display: block;
        position: absolute;
        top: -20px;
        left: -20px;
        content: "";
        width: 150%;
        height: 40px;
        transform: rotate(-10deg);
        background-color: #EEEEEE;
        z-index: 0;
    }
`;

export const ChannelName = styled.p`
    ${FONTS.S};
    margin-left: 13px;
    color: ${COLORS.TextPrimary};
    max-width: 160px;

    @media only screen and (max-width: 1023px) {
        flex-direction: column;
        align-items: flex-start;
        margin-top: 10px;
        margin-left: 0;
    }
`;
